<template>
  <v-menu v-if="locales && locales.length > 1" close-on-click close-on-content-click offset-y transition="scroll-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <span class="body-1">{{ lang.flag }}</span>
      </v-btn>
    </template>

    <v-list dense nav>
      <v-list-item v-for="locale in locales" :key="locale.code" @click="onClickSwitchLang(locale.code)">
        <v-list-item-title
          :class="{ 'body-1': true, 'primary--text': locale.code === lang.code}"
        >{{ locale.flag.toUpperCase() }} ({{ locale.name }})</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { setI18nLanguage } from '@/plugins/i18n'

const allLocales  = [
  { code: 'uk', name: 'Українська', flag: 'ua', rtl: false },
  { code: 'ru', name: 'Русский', flag: 'ru', rtl: false },
  { code: 'en', name: 'English', flag: 'en', rtl: false },
  { code: 'ar', name: 'Arabian', flag: 'ar', rtl: true }
]

export default {
  name: 'LangSwitcher',
  data: () => ({
    defaultLocales: [
      { code: 'uk', name: 'Українська', flag: 'ua', rtl: false },
      { code: 'ru', name: 'Русский', flag: 'ru', rtl: false },
      { code: 'en', name: 'English', flag: 'en', rtl: false }
    ]
  }),
  created() {
    let foundLocale = this.locales.find(lang => lang.code === this.$i18n.locale)
    if (!foundLocale) {
      this.setLang(this.locales[0].code)
    }
    this.setRTL(this.$i18n.locale)
  },
  mounted() {
    this.$emit('afterSetLangFunc')
  },
  computed: {
    lang: {
      get() {
        return this.locales.find(lang => lang.code === this.$i18n.locale)
      },
      set(lang) {
        this.setRTL(lang)
        this.setLang(lang)
        window.location.reload()
      }
    },
    locales() {
      let modelLocales = this.$store.state.appRunner.model.Settings.Locales
      if (!modelLocales?.length) {
        return this.defaultLocales
      }
      // Языки из модели
      let locales = []
      for (let i = 0; i < modelLocales.length; i++) {
        let item = allLocales.find( x => x.code === modelLocales[i])
        locales.push(item)
      }

      return locales
    }
  },
  methods: {
    setRTL(lang) {
      let rtl = !!this.locales.find(x => x.code === lang)?.rtl
      this.$vuetify.rtl = rtl
    },
    async setLang(lang) {
      // sync ?lang= in URL so it does not override new locale after reload
      const url = new URL(window.location.href)
      if (url.searchParams.get('lang') !== lang) {
        url.searchParams.set('lang', lang)
        window.history.replaceState({}, '', url.toString())
      }
      setI18nLanguage(lang)
      this.$vuetify.lang.current = lang
      
      const { status, systemLocalization, userLocalization } = await this.$store.dispatch('changeLocaleAsync', lang)
      if (!status) {
        return
      }

      let i18n = this.$i18n
      const applyLocaization = function (localization) {
        try {
          // если массив, значит приложение имеет несколько модулей с локализацией
          if (Array.isArray(localization)) {
            localization.forEach(x => i18n.mergeLocaleMessage(i18n.locale, JSON.parse(x)))
          } else {
            i18n.mergeLocaleMessage(i18n.locale, localization)
          }
        } catch (err) {
          console.error('Something wrong during apply localization: ', err)
        }
      }

      applyLocaization(systemLocalization)
      applyLocaization(userLocalization)

      // принудительно обновляем ещё раз локализацию
      this.$i18n.locale = undefined
      this.$i18n.locale = lang
    },
    onClickSwitchLang(langCode) {
      this.lang = langCode
      let query = location.search
      let param = ''
      let needAddLang = false
      if (location.search.indexOf('?') >= 0) {
        query = location.search.substring(location.search.indexOf('?') + 1)
        let parts = query.split('&')
        if (parts.length == 0 || (parts.length == 1 && !parts[0])) {
          needAddLang = true
        } else {
          param = parts.find(e => e.includes('proj'))
          if (!param) {
            needAddLang = true
          }
        }
      } else {
        needAddLang = true
      }
      if (needAddLang) {
        let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
        let projectCode = data?.data?.iTEnterpriseMenuQuery.menu.currentProject
        if (projectCode) {
          location.search = `${(location.search.indexOf('?') >= 0 ? `${location.search}&` : '?')}proj=${projectCode.replace(projectCode, projectCode.substring(0, projectCode.length - 2))}${langCode}`
        }
      } else {
        location.search = `${location.search.replace(param, param.substring(0, param.length - 2))}${langCode}`
      }
    }
  }
}
</script>

<style scoped>
</style>
